<script>
    export let value = null, reportType;
    let val = value;
    let defaultValue = {
        amount: 20,
        condition: 0,
        format: 2,
        period: (reportType == 'weekly') ? 2 : 0
    };

    const metricFormats = {
        '2': '%',
        '4': 'X'
    };
    const metricConditions = ['Less than goal', 'Below goal', 'Increase of'];
    const metricPeriods = ['Within Month', 'Last Three Months', 'Within Week'];

    try {
        val = val ? JSON.parse(value) : defaultValue;
    } catch(e) {
        console.log(e);

        val = defaultValue;
    }

    function updateData(conditionChanged = false) {
        if(conditionChanged) val.format = (val.condition == 1)? 4 : 2;
        value = JSON.stringify(val);
    }

    $: val;

</script>

<div class="form-group row">
    <div class="form-group col-2">
        <label for="taxonmyInput">Amount</label>
        <input bind:value={val.amount} maxlength="128" on:change="{() => updateData()}" type="text" class="form-control" placeholder="0">
    </div>
    <div class="form-group col-2">
        <label for="formulaInput">Format</label>
        <input type="text" class="form-control" disabled bind:value={metricFormats[val.format]}>
    </div>
    <div class="form-group col-4">
        <label for="formulaInput">Condition</label>
        <select bind:value={val.condition} class="form-control"  on:change="{() => updateData(true)}">
            {#each metricConditions as condition, conditionId}
                <option value={conditionId}>{condition}</option>
            {/each}
        </select>
    </div>
    <div class="form-group col-4">
        <label for="formulaInput">Time Period</label>
        <select bind:value={val.period} class="form-control" on:change="{() => updateData()}">
            {#each metricPeriods as period, periodId}
                <option value={periodId}
                  disabled={ (reportType == 'weekly' && periodId != 2) || (reportType == 'monthly' && periodId == 2)}
                >
                    {period}
                </option>
            {/each}
        </select>
    </div>
    <div class="col-12">
        <p><b>Metric:</b> {val.amount} {metricFormats[val.format]} {metricConditions[val.condition]} {metricPeriods[val.period]}</p>
    </div>
</div>